<template>
  <div class="mr-4 ml-4">
    <div class="row">
      <div class="col-12">
        <page-header
          class="page-header-family-text"
          :actions="headerActionsConfig"
          left-side-class="col-12 col-md-7"
          :page="headerConfig"
          right-side-class="col-12 col-md-5 d-flex mt-5"
        />
      </div>
    </div>

    <div v-if="isSubmittedStatus">
      <div v-if="studentSie" class="related-sie-container">
        <icon-view
          class="mr-2 mt-3 rounded-circle icon-view-color-text"
          icon="fas fa-info mb-1"
          icon-background="white"
          icon-color="#FF7058"
          icon-size="16px"
          title="Información de SIE Relacionado"
          :gradient="true"
        />
        <div class="container row ml-3 mt-4">
          <span class="data-title d-block col-12"> Número de SIE: </span>
          <span class="color-black font-16 col-12">
            {{ studentSie | empty }}
          </span>
        </div>
      </div>
      <div
        v-if="canRelatedSie && !studentSie"
        class="col-12 row relate-sie-container bg-light custom-rounded p-4  ml-1"
      >
        <validation-observer ref="relateStudentForm" class="col-12">
          <icon-view
            class="rounded-circle icon-view-color-text"
            icon="fas fa-user-tag mb-1"
            icon-background="white"
            icon-color="#FF7058"
            icon-size="16px"
            title="Relacionar SIE"
          />
          <span class="data-title d-block mt-3">Número de SIE:</span>
          <validation-provider
            v-slot="{ errors }"
            rules="required|studentSie"
            name="relatedStudent"
            class="row pb-3"
            :custom-messages="{
              required: 'El número de SIE es requerido.',
              studentSie: 'El número de SIE no es correcto.'
            }"
          >
            <div class="related-sie-wrapper col-3 row">
              <custom-input
                id="related-sie-input"
                v-model.trim="relatedStudentSie"
                type="tel"
                placeholder="Escriba número de SIE"
                class="col-12"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                maxlength="8"
              />
            </div>
            <div class="d-flex align-items-start col">
              <action-button
                id="relate-student-button"
                i="fa fa-user-friends"
                variant="success"
                @click="handleRelatedStudent"
              >
                Relacionar</action-button
              >
              <action-button
                id="clear-related-student-button"
                i="fa fa-times-circle"
                v-show="relatedStudentSie"
                variant="outline-danger"
                class="ml-3"
                @click="clearRelateSieValidation"
                >Cancelar</action-button
              >
            </div>
          </validation-provider>
        </validation-observer>
      </div>
      <div v-if="isSubmittedStatus && !canEditHealthRegion" class="related-sie-container">
        <icon-view
          class="mr-2 mt-3 rounded-circle icon-view-color-text"
          icon="fas fa-building mb-1"
          icon-background="white"
          icon-color="#FF7058"
          icon-size="16px"
          title="Información de Región de Salud"
          :gradient="true"
        />
        <div class="container row ml-3 mt-4">
          <div class="col-md-3">
            <span class="data-title d-block mb-2"
              >Fecha de Referido Parte C:</span
            >
            <p>{{ partCDate | date }}</p>
          </div>
          <div class="col-md-3">
            <span class="data-title d-block mb-2"
              >Fecha de Referido Parte B:</span
            >
            <p>{{ dateB | date }}</p>
          </div>
          <div class="col-md-3">
            <span class="data-title d-block mb-2">Región de Salud:</span>
            <p>{{ healthRegion.name }}</p>
          </div>
          <div class="col-md-3">
            <span class="data-title d-block mb-2">Número de Solicitud:</span>
            <p>{{ caseNumber }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class=" container-region" v-if="!isSubmittedStatus || canEditHealthRegion">
      <icon-view
        class="mr-2 mt-3  mb-3  rounded-circle icon-view-color-text"
        icon="fas fa-building mb-1"
        icon-background="white"
        icon-color="#FF7058"
        icon-size="16px"
        title="Información de Región de Salud"
        :gradient="true"
      />
      <div class="row">
        <div class="col-md-3 ml-5">
          <span class="data-title d-block mb-2">Región de Salud:</span>
          <validation-observer ref="healthRegionRef" slim>
            <validation-provider
              v-slot="{ errors }"
              ref="healthRegionProvider"
              rules="required"
            >
              <CustomDropDown
                id="customDropDownHealtRegion"
                class=" "
                v-model="healthRegion"
                custom-error-msg="La región de salud es requerida."
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                :error="errors[0]"
                :options="optionsHealtRegion"
                :disabled="isEditable && !canEditHealthRegion"
              />
            </validation-provider>
          </validation-observer>
        </div>
        <div class="col-md-3 mb-3">
          <span class="data-title d-block mb-2">Fecha de Referido Parte C:</span>
          <validation-observer ref="partCDateRef" slim>
            <validation-provider
              v-slot="{ errors }"
              name="partCDate"
              rules="required"
            >
              <custom-date-picker
                v-model="partCDate"
                :class-container="'w-100'"
                custom-error-msg="La fecha parte C es requerida."
                :error="errors[0]"
                format="dd/MMM./yyyy"
                :max-date="currentDate"
                :disabled="isEditable"
              />
            </validation-provider>
          </validation-observer>
        </div>
        <div class="col-md-3 mb-3" v-if="isEditable">
          <span class="data-title d-block mb-2">Fecha de Referido Parte B:</span>
          <validation-observer ref="partBDateRef" slim>
            <validation-provider
              v-slot="{ errors }"
              name="partBDate"
              rules="required"
            >
              <custom-date-picker
                v-model="dateB"
                :class-container="'w-100'"                
                :error="errors[0]"
                format="dd/MMM./yyyy"              
                disabled
              />
            </validation-provider>
          </validation-observer>
        </div>
        <div class="col-md-2">
          <span class="data-title d-block mb-2">Número de Solicitud:</span>
          <p>{{ caseNumber }}</p>
        </div>
      </div>
    </div>
    <icon-view
      class="mr-2 mt-5 rounded-circle icon-view-color-text"
      icon="fas fa-address-book mb-1"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      title="Información del(la) Niño(a)"
      :gradient="true"
    />
    <div class="ml-5">
      <validation-observer ref="boyGirlInfoForm" v-slot="{}" tag="form">
        <div class="row mt-4">
          <div class="col-md-4 col-sm-12 mb-3">
            <span class="data-title d-block mb-2"
              >Fecha de la Reunión de Transición:</span
            >
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomTransitionDate"
              rules="required"
            >
              <custom-date-picker
                v-if="!isEditable"
                v-model="dateTransition"
                :class-container="'w-100'"
                custom-error-msg="La fecha de la reunión de transición es requerida."
                :error="errors[0]"
                format="dd/MMM./yyyy"
                :disabled="isEditable"
                :max-date="currentDate"
              />
              <p v-else class="only-read">{{ dateTransition | date }}</p>
            </validation-provider>
          </div>
          <div class="col-md-4 col-sm-12">
            <span class="data-title d-block mb-2">Género:</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomGender"
              rules="required"
            >
              <CustomDropDown
                class="select-dropdown"
                v-if="!isEditable"
                id="customDropDownHealtRegion"
                v-model="gender"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="El género es requerido."
                :error="errors[0]"
                :options="optionsGender"
                :disabled="isEditable"
              />
              <p v-else class="only-read">{{ gender.name }}</p>
            </validation-provider>
          </div>
          <div class="col-md-4 col-sm-12">
            <span class="data-title d-block mb-2">Etnicidad:</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomEtnia"
              rules="required"
            >
              <CustomDropDown
                class="select-dropdown"
                v-if="!isEditable"
                id="customDropDownHealtRegion"
                v-model="ethnicities"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="La etnicidad es requerida."
                :error="errors[0]"
                :options="optionsEthnicities"
                :disabled="isEditable"
              />
              <p v-else class="only-read">{{ ethnicities.name }}</p>
            </validation-provider>
          </div>
          <div class="col-md-4  col-sm-12 mb-3">
            <span class="data-title d-block mb-2">Nombre:</span>
            <validation-provider
              v-slot="{ errors }"
              ref="firstNameProvider"
              name="validationCustomtNameBoy"
              rules="required"
            >
              <CustomInput
                v-if="!isEditable"
                id="CustomInputNumberSS"
                v-model="name"
                custom-error-msg="El nombre es requerido."
                :error="errors[0]"
                :disabled="isEditable"
              />
              <p v-else class="only-read">{{ name }}</p>
            </validation-provider>
          </div>
          <div class="col-md-4 col-sm-12">
            <span class="data-title d-block mb-2">Inicial:</span>
            <CustomInput
              v-if="!isEditable"
              id="CustomInputNumberSS"
              v-model="initials"
              :disabled="isEditable"
            />
            <p v-else class="only-read">{{ initials ? initials : "-" }}</p>
          </div>
          <div class="col-md-4 col-sm-12">
            <span class="data-title d-block mb-2">Apellidos:</span>
            <validation-provider
              v-slot="{ errors }"
              ref="lastNameProvider"
              name="validationCustomInputLastNameBoy"
              rules="required"
            >
              <CustomInput
                v-if="!isEditable"
                id="CustomInputNumberSS"
                v-model="lastName"
                custom-error-msg="Los apellidos son requeridos."
                :error="errors[0]"
                :disabled="isEditable"
              />
              <p v-else class="only-read">{{ lastName }}</p>
            </validation-provider>
          </div>
          <div class=" col-md-4 col-sm-12">
            <span class="data-title d-block mb-2">Fecha de Nacimiento:</span>
            <validation-provider
              v-slot="{ errors }"
              name="validationCustomBornDate"
              rules="required"
            >
              <custom-date-picker
                v-if="!isEditable"
                v-model="bornDate"
                :class-container="'w-100'"
                custom-error-msg="La fecha de nacimiento es requerida."
                :error="errors[0]"
                format="dd/MMM./yyyy"
                :disabled="isEditable"
                :max-date="currentDate"
              />
              <p v-else class="only-read">{{ bornDate | date }}</p>
            </validation-provider>
          </div>

          <div class="col-md-4 col-sm-12">
            <span class="data-title d-block mb-2">Edad a la Transición:</span>
            <p>{{ age }}</p>
            <div
              v-if="!ageIsValid"
              class="w-100 text-left text-error detail-referral-custom-error"
            >
              <div class="d-inline">
                <em class="fa fa-times-circle"></em>
              </div>
              <p class="text-left d-inline">
                La edad mínima del niño(a) permitida es de
                {{ minimumAge }} años.
              </p>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <span class="data-title d-block mb-2"
              >Número de Seguro Social:</span
            >
            <div v-if="!isEditable" class="row">
              <CustomInput
                id="CustomInputSsnDetailReferral"
                ref="ssnDetailInputRef"
                v-show="!showSsn"
                :value="sSnumber"
                :error="customSsnErrors[0]"
                placeholder="xxx-xx-xxxx"
                mask-type="Encryptedssn"
                maxlength="9"
                :class="hasViewSsnPermission ? 'col-10 pr-0' : 'col-12'"
                @input="onSsnChange"
              />
              <CustomInput
                id="CustomInputSsnDetailReferral"
                v-if="hasViewSsnPermission"
                v-show="showSsn"
                :value="unmaskedSsnumber"
                :error="customSsnErrors[0]"
                placeholder="xxx-xx-xxxx"
                mask-type="Personalssn"
                maxlength="11"
                :class="hasViewSsnPermission ? 'col-10 pr-0' : 'col-12'"
                @input="onSsnModelChange"
              />
              <div
                v-if="hasViewSsnPermission"
                class="col-1 d-flex align-items-center fa-lg"
              >
                <i
                  class="fa cursor-pointer pl-1"
                  @click="showSsn = !showSsn"
                  :class="[ssnMaskedClass]"
                />
              </div>
            </div>
            <div v-else class="row">
              <div class="col-4 only-read">
                <p v-if="!showSsnLabel">{{ unmaskedSsnumber | maskSSN }}</p>
                <p v-else>{{ unmaskedSsnumber | unmaskSSN }}</p>
              </div>
              <div
                v-if="hasViewSsnPermission"
                v-show="unmaskedSsnumber"
                class="col fa-lg"
              >
                <i
                  class="fa cursor-pointer"
                  @click="showSsnLabel = !showSsnLabel"
                  :class="showSsnLabel ? 'fa-eye' : 'fa-eye-slash'"
                />
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
    <icon-view
      class="mr-2 mt-5 rounded-circle icon-view-color-text"
      icon="fas fa-user-tag mb-1 mb-1 "
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      title="Información del(los) Pariente(s)"
      :gradient="true"
    />

    <div v-if="contacts.length > 0">
      <div v-for="(item, idx) in contacts" :key="idx" class="ml-5">
        <callout :has-toggle="false" class="mt-3" :controlled="true">
          <div class="row mt-3 mb-3">
            <div class="col-md-1 col-sm-12">
              <div class="phone-icon mt-2">
                <i class="fas fa-phone-alt"></i>
              </div>
            </div>
            <div class="col-md-2 col-sm-12">
              <span class="data-title d-block mb-2">Nombre del Pariente:</span>
              <strong> {{ item.name }} {{ item.surname }}</strong>
            </div>
            <div class="col-md-2 col-sm-12">
              <span class="data-title d-block mb-2">Parentesco:</span>
              {{ item.relationship }}
            </div>
            <div class="col-md-2 col-sm-12">
              <span class="data-title d-block mb-2">Correo Electrónico:</span>
              {{ item.email }}
            </div>
            <div class="col-md-2 col-sm-12">
              <span class="data-title d-block mb-2">Teléfono 1:</span>
              {{ getPhoneMasked(item.phone1) }}
            </div>
            <div class="col-md-2 col-sm-12">
              <span class="data-title d-block mb-2">Teléfono 2:</span>

              {{ item.phone2 ? getPhoneMasked(item.phone2) : "-" }}
            </div>
            <div class="col-md-1 col-sm-12 d-flex justify-content-end">
              <div
                class="edit-icon mr-5 mt-3"
                @click="showEdit(item)"
                v-if="!item.showEditParentInformation && !isEditable"
              >
                <i class="fas fa-pen fa-sm"></i>
              </div>
            </div>
          </div>
        </callout>
        <parent-information
          v-if="item.showEditParentInformation"
          :options-relationships="optionsRelationships"
          :dto="item"
          @cancel="onCloseEditParentInformation(item)"
          @save="onSaveParentInformation($event, item)"
        />
      </div>
    </div>
    <CustomResultNotFound
      v-else
      class="mt-4 row pt-3"
      text="No se ha encontrado resultados."
    />
    <div v-if="showRelationError" class="ml-5 detail-referra-custom-error">
      <i class="fa fa-times-circle" />
      <span>La información de contacto es requerida.</span>
    </div>
    <div class="text-right">
      <ActionButton
        variant="success mt-3"
        text="Añadir"
        i="fas fa-file-plus"
        v-if="!showParentInformation && !this.isEditable"
        @click="onShowParentInformation()"
      />
      <parent-information
        class="ml-5"
        v-if="showParentInformation"
        :options-relationships="optionsRelationships"
        :dto="null"
        @cancel="onCloseParentInformation()"
        @save="onSaveParentInformation($event)"
      />
    </div>
    <icon-view
      class="mr-2 mt-5 rounded-circle icon-view-color-text"
      icon="fas fa-map-marker-alt mb-1 mb-1 "
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      title="Información de Dirección(es)"
      :gradient="true"
    />
    <div class="ml-5">
      <callout :has-toggle="false" class="mt-3" :controlled="true">
        <div class="row mt-3 mb-3">
          <div class="col-md-1 col-sm-12">
            <div class="phone-icon mt-2">
              <i class="fas fa-map-marker-alt"></i>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <span class="data-title d-block mb-2">Tipo de Dirección:</span>
            <strong> Física </strong>
          </div>
          <div class="col-md-7 col-sm-12">
            <span class="data-title d-block mb-2">Dirección Física:</span>
            {{ formatAddress(addresses.physical.initial) }}
          </div>
          <div class="col-md-1 col-sm-12 d-flex justify-content-end">
            <div
              v-if="!isEditable || hasEditPermission"
              class="edit-icon mr-5"
              @click="showEditAddress(addresses.physical.model)"
            >
              <i class="fas fa-pen"></i>
            </div>
          </div>
        </div>
      </callout>
      <address-information
        v-if="addresses.physical.model.isEdit"
        title="Editar Dirección Fisica"
        ref="physicalAddressRef"
        v-model="addresses.physical.model"
        :municipalities="optionsMunicipalities"
        @cancel="cancelPhysicalAddress"
        @save="saveAddressInformation($event, addresses.physical.model)"
        @invalid-address="onInvalidAddress($event)"
        @input="onChangePhysicalAddress"
      />
      <div
        v-if="addresses.physical.model.showError"
        class="detail-referra-custom-error"
      >
        <i class="fa fa-times-circle" />
        <span>La información de Dirección Física es requerida.</span>
      </div>
    </div>

    <div class="ml-5">
      <callout :has-toggle="false" class="mt-3" :controlled="true">
        <div class="row mt-3 mb-3">
          <div class="col-md-1 col-sm-12">
            <div class="phone-icon mt-2">
              <i class="fas fa-map-marker-alt"></i>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <span class="data-title d-block mb-2">Tipo de Dirección:</span>
            <strong> Postal</strong>
          </div>
          <div class="col-md-7 col-sm-12">
            <span class="data-title d-block mb-2">Dirección Postal:</span>
            {{ formatAddress(addresses.postal.initial) }}
          </div>
          <div class="col-md-1 col-sm-12 d-flex justify-content-end">
            <div
              v-if="!isEditable || hasEditPermission"
              class="edit-icon mr-5"
              @click="showEditAddress(addresses.postal.model)"
            >
              <i class="fas fa-pen"></i>
            </div>
          </div>
        </div>
      </callout>
      <address-information
        title="Editar Dirección Postal"
        ref="postalAddressRef"
        v-if="addresses.postal.model.isEdit"
        v-model="addresses.postal.model"
        :municipalities="optionsMunicipalities"
        @cancel="cancelPostalAddress"
        @save="saveAddressInformation($event, addresses.postal.model)"
        @check-same-address-than-physical="copyFisicalAddress($event)"
        @invalid-address="onInvalidAddress($event)"
        is-postal
      />
      <div
        v-if="addresses.postal.model.showError"
        class="detail-referra-custom-error"
      >
        <i class="fa fa-times-circle" />
        <span>La información de Dirección Postal es requerida.</span>
      </div>
    </div>

    <div>
      <icon-view
        class="mr-2 mt-5 rounded-circle icon-view-color-text"
        icon="fas fa-comment mb-1 mb-1 "
        icon-background="white"
        icon-color="#FF7058"
        icon-size="16px"
        title="Información Adicional"
        :gradient="true"
      />
      <div class="container-form mt-3 ml-5">
        <custom-text-area
          v-if="!isSubmittedStatus"
          v-model="additionalComment"
          label="Comentario:"
          :maxlength="3000"
          show-char-count
          :count-classes="['d-block text-right']"
          :disabled="isEditable"
        />
        <div v-else class="mt-4">
          <span class="data-title d-block col-12">Comentario: </span>
          <span class="color-black font-16 col-12">
            {{ additionalComment | empty }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from "PageHeader";
import IconView from "icon-view";
import CustomInput from "CustomInput";
import CustomDatePicker from "custom-date-picker";
import CustomDropDown from "@/components/common/CustomDropDown";
import StudentServices from "@/services/pc/referral-student";
import Callout from "custom-callout";
import ActionButton from "@/components/common/ActionButton";
import CustomResultNotFound from "custom-result-not-found";
import CustomTextArea from "CustomTextArea";
import ParentInformation from "./ParentInformation";
import AddressInformation from "./AddressInformation";
import storeMixin from "@quisit/mipe-utils/mixins/storeGenerator";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin";
import { masker, tokens } from "ke-the-mask";
import referralStatus from "@/utils/constants/student/referralStatus";
import PeiCode from "@/utils/constants/pei/peiCode";
import store from "@/store/index";
import dateUtil from "@/utils/dateUtil.js";
import Ages from "@/utils/constants/student/partCpartBAges";
import { publicPortalRequestTypes } from "@/utils/constants/student/publicPortalRequestTypes.js";

const validationResponseType = {
  duplicated: 1
};

export default {
  name: "detailReferral",
  mixins: [alertMixin, storeMixin],
  components: {
    PageHeader,
    IconView,
    CustomInput,
    CustomDatePicker,
    Callout,
    CustomDropDown,
    ActionButton,
    CustomResultNotFound,
    CustomTextArea,
    ParentInformation,
    AddressInformation
  },
  computed: {
    isEditable() {
      return this.referralStatusId !== referralStatus.New;
    },
    hasEditPermission(){              
      return this.userHasPermissions('student.partcpartbreferral.editaddress');
    },
    calculateAge() {
      let age = dateUtil.calculateAge(this.bornDate);

      this.ageIsValid = false;
      if (age > 0) {
        this.ageIsValid = age >= this.minimumAge;

        return age.toFixed(2);
      } else {
        return "-";
      }
    },
    minimumAge() {
      return Ages.MINIMUM_AGE;
    },
    maximumAge() {
      return Ages.MAXIMUM_AGE;
    },
    validationAge() {
      return Ages.VALIDATION_AGE;
    },
    headerConfig() {
      return {
        title: "Detalle de Proceso del Referido",
        icon: "fas fa-user-circle",
        routes: ["Inicio", "Estudiante", "Ver Detalle de Proceso del Referido"]
      };
    },
    headerActionsConfig() {
      return [
        {
          text: "Regresar",
          icon: "fas fa-arrow-circle-left pr-1 ",
          variant: "outline-success",
          click: () => {
            this.$router.push({ name: "referralPartCToPartB" });
          }
        },
        {
          text: "Crear - Pre-Registro",
          icon: "fas fa-user-friends fa-fw pr-1 ",
          variant: "outline-success",
          visible: this.isRelatedStatus,
          click: () => {
            this.createPreRegister();
          }
        },
        {
          text: "Guardar",
          icon: "fas fa-save  pr-1",
          variant: "success",
          visible: !this.isEditable || this.canEditHealthRegion,
          click: () => {
            this.save();
          }
        },
        {
          text: "Someter",
          icon: "fas fa-flag pr-1",
          variant: "success",
          visible: !this.isEditable,
          click: () => {
            this.submit();
          }
        }
      ];
    },
    isSubmittedStatus() {
      return this.referralStatusId === referralStatus.Submitted;
    },
    isRelatedStatus() {
      return this.referralStatusId === referralStatus.Related;
    },
    ssnMaskedClass() {
      return this.showSsn ? "fa-eye" : "fa-eye-slash";
    },
    hasViewSsnPermission() {
      return store.getters.HasPermission("student.partcpartbreferral.viewssn");
    },
    canRelatedSie() {
      return this.userHasPermissions("student.referralcparttobpart.relatedsie");
    },
    locations() {
      return [this.physicalAddress, this.postalAddress];
    },
    canEditHealthRegion() {
      return this.isSubmittedStatus && this.userHasPermissions("student.partcpartbreferral.canedithealthregion");
    }
  },
  data() {
    return {
      pcStudentId: 0,
      dateB: null,
      caseNumber: null,
      currentDate: new Date(),
      dateTransition: null,
      sSnumber: null,
      name: null,
      lastName: null,
      bornDate: null,
      age: null,
      gender: {},
      initials: null,
      ethnicities: {},
      healthRegion: null,
      contacts: [],
      optionsHealtRegion: [],
      optionsEthnicities: [],
      optionsGender: [],
      optionsRelationships: [],
      optionsMunicipalities: [],
      showParentInformation: false,
      referralStatusId: null,
      studentSie: null,
      relatedStudentSie: null,
      peiCode: PeiCode,
      showRelationError: false,
      model: {},
      customSsnErrors: [],
      showSsn: false,
      showSsnLabel: false,
      ageIsValid: true,
      unmaskedSsnumber: null,
      ssnSnapshot: null,
      enableCopyFisicalAddress: false,
      partCDate: null,
      additionalComment: null,
      requesTypeId: null,
      addresses: {
        physical: {
          initial: {
            address1: null,
            address2: null,
            municipality: null,
            zipCode: null
          },
          model: {
            address1: null,
            address2: null,
            municipality: null,
            zipCode: null
          }
        },
        postal: {
          initial: {
            address1: null,
            address2: null,
            municipality: null,
            zipCode: null
          },
          model: {
            address1: null,
            address2: null,
            municipality: null,
            zipCode: null
          }
        }
      }
    };
  },
  async mounted() {
    this.pcStudentId = Number(this.$route.params.pcStudentId);
    await this.getDataSelect();
    await this.loadReferralDetail();
  },
  methods: {
    async createPreRegister() {
      let data;

      if (this.requestTypeId == publicPortalRequestTypes.HealthReferral) {
        const {
          data: dataResult
        } = await StudentServices.validateCreationPreRegister(
          this.pcStudentId
        );
        data = dataResult;
      } else {
        const {
          data: dataResult
        } = await StudentServices.validateCreationPreRegisterFromPublicPortal(
          this.pcStudentId
        ).catch(err => {
          this.ShowToast(
            "Alerta",
            err.response.data.message || "error",
            "error"
          );
        });
        data = dataResult;
      }

      if (data.hasOwnProperty("isValid") && !data?.isValid) {
        this.ShowToast("Error", data.errorMessage, "error");
        return;
      }

      let confirmResult = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro(a) que desea realizar el pre-registro del estudiante ${this.name} ${this.lastName}-${this.studentSie}?`,
        "Si",
        "No"
      );
      if (confirmResult) {
        if (this.requestTypeId == publicPortalRequestTypes.HealthReferral) {
          await StudentServices.createPreRegister(this.pcStudentId);
          await this.getDataSelect();
          await this.loadReferralDetail();
        } else {
          await StudentServices.createPreRegisterFromPublicPortal(
            this.pcStudentId
          );
        }

        this.ShowToast(
          "Proceso exitoso",
          "Se ha creado el pre-registro del estudiante exitosamente.",
          "success"
        );
      }
    },
    getPhoneMasked(phone) {
      if (!phone) return phone;
      return masker(phone, "(###)###-####", true, tokens);
    },
    formatAddress(item) {
      return `${item.address1 ?? ""}${
        item.address2 ? ", " + item.address2 : ""
      }${
        item.municipality ? ", " + item.municipality.name + ", PR" : ""
      } ${this.formatZipCode(item.zipCode) ?? ""}`;
    },
    formatZipCode(item) {
      if (!item) {
        return null;
      }
      let formatedZip = item;
      if (item.length > 5) {
        formatedZip = `${item.substring(0, 5)}-${item.substring(5)}`;
      }

      return formatedZip;
    },
    setLocations(locations) {
      const physical = locations.find(
        x => x.addressTypeId === this.peiCode.Fisica
      );
      const physicalModel = {
        ...physical,
        isEdit: false,
        showError: false,
        municipality: this.optionsMunicipalities.find(
          m => m.id == physical.municipalityId
        )
      };
      this.addresses.physical.initial = { ...physicalModel };
      this.addresses.physical.model = { ...physicalModel };

      const postal = locations.find(
        x => x.addressTypeId === this.peiCode.Postal
      );
      const postalModel = {
        ...postal,
        isEdit: false,
        showError: false,
        municipality: this.optionsMunicipalities.find(
          m => m.id == postal.municipalityId
        )
      };
      this.addresses.postal.initial = { ...postalModel };
      this.addresses.postal.model = { ...postalModel };
      this.enableCopyFisicalAddress = false;
    },
    generateKey() {
      return Math.floor(Math.random() * 1000);
    },
    copyFisicalAddress(value) {
      this.enableCopyFisicalAddress = value;
      this.onChangePhysicalAddress();
    },
    onSsnChange({ internalValue, encryptedValue }) {
      this.sSnumber = encryptedValue;
      this.unmaskedSsnumber = internalValue;
    },
    onSsnModelChange(newValue) {
      if (!newValue) {
        this.sSnumber = null;
        this.unmaskedSsnumber = null;
        return;
      }

      const cleanVal = newValue.replace(/-/g, "");
      this.unmaskedSsnumber = cleanVal;
      this.sSnumber = this.transformSsnDisplay(cleanVal);
    },
    onSsnModelLoad(initialValue) {
      if (!initialValue) return;

      this.onSsnModelChange(initialValue);
      this.$refs.ssnDetailInputRef.ssnInput = {
        ...this.$refs.ssnDetailInputRef.ssnInput,
        internalValue: initialValue,
        encryptedValue: this.transformSsnDisplay(initialValue)
      };
    },
    transformSsnDisplay(val = "") {
      let displayVal = val.replace(/[^0-9|\\•]/g, "");
      displayVal = displayVal.substr(0, 9);
      if (displayVal.length < 6) return displayVal.replace(/[0-9]/g, "•");
      else return "•".repeat(5) + val.slice(5);
    },
    onCloseEditParentInformation(item) {
      this.showRelationError = false;
      this.contacts.find(
        x => x.id === item.id
      ).showEditParentInformation = false;
      this.$forceUpdate();
    },
    onCloseParentInformation() {
      this.showRelationError = false;
      this.showParentInformation = false;
    },
    onShowParentInformation() {
      this.showRelationError = false;
      this.showParentInformation = true;
    },
    onSaveParentInformation(parentModel, item = null) {
      this.showRelationError = false;
      const data = {
        ...parentModel,
        pcStudentId: this.pcStudentId
      };
      StudentServices.saveParentInformation(data).then(result => {
        var msg = "La información ha sido añadida exitosamente.";
        if (item != null) {
          msg = "La información ha sido actualizada exitosamente.";
        }
        this.showParentInformation = false;
        this.ShowToast("Proceso exitoso.", msg, "success");
        StudentServices.getParents(this.pcStudentId).then(data => {
          this.contacts = data.data;
        });
      });
    },
    showEditAddress(item) {
      item.showError = false;
      item.isEdit = true;
    },
    cancelPhysicalAddress() {
      this.addresses.physical.model = {
        ...this.addresses.physical.initial
      };
      this.addresses.physical.model.showError = false;
      this.addresses.physical.model.isEdit = false;
    },
    cancelPostalAddress() {
      this.addresses.postal.model = {
        ...this.addresses.postal.initial
      };
      this.addresses.postal.model.showError = false;
      this.addresses.postal.model.isEdit = false;
    },
    async saveAddressInformation(model, item) {
      try {
        item.isEdit = false;
        const payload = {
          id: model.id,
          type: model.type,
          zipCode: model.zipCode,
          address1: model.address1,
          address2: model.address2,
          addressTypeId: model.addressTypeId,
          municipalityId: model.municipality.id
        };

        await StudentServices.saveAddressInformation(payload);
        this.ShowToast(
          "Proceso exitoso.",
          "La información ha sido actualizada exitosamente.",
          "success"
        );

        const { data } = await StudentServices.getAddress(this.pcStudentId);
        this.setLocations(data);
      } catch (error) {
        this.ShowToast(
          "",
          error.message || error.response.data.message,
          "error"
        );
      }
    },
    onInvalidAddress(model) {
      const isPostal = model.addressTypeId === this.peiCode.Postal;
      const name =
        isPostal && this.enableCopyFisicalAddress ? "Física" : model.type;
      this.ShowToast(
        "",
        `La información de la Dirección ${name} debe ser completada.`,
        "error"
      );
    },
    showEdit(item) {
      this.contacts.find(
        x => x.id === item.id
      ).showEditParentInformation = true;
      this.$forceUpdate();
    },
    getData() {},
    getRelationShipById(id) {
      return this.optionsRelationships.find(x => x.id === id);
    },
    getEthnicityById(id) {
      return this.optionsEthnicities.find(x => x.id === id) ?? null;
    },
    getGenderById(id) {
      return this.optionsGender.find(x => x.id === id) ?? null;
    },
    getHealthRegionById(id) {
      return this.optionsHealtRegion.find(x => x.id === id) ?? null;
    },
    async getDataSelect() {
      await StudentServices.getStudentSelect().then(({ data }) => {
        const dataRoute = data;
        this.optionsEthnicities = dataRoute.ethnicities;
        this.optionsGender = dataRoute.genders;
        this.optionsRelationships = dataRoute.relationships;
        this.optionsMunicipalities = dataRoute.municipalities;
        this.optionsHealtRegion = dataRoute.healthRegions;
      });
    },
    async loadReferralDetail() {
      const { data } = await StudentServices.getDetailReferal(this.pcStudentId);
      this.caseNumber = data.caseNumber;
      this.age = data.age;
      this.name = data.firstName;
      this.lastName = data.lastName;
      this.bornDate = data.birthDate;
      this.initials = data.middleName;
      this.dateTransition = data.meetingTransitionDate;
      this.dateB = data.referralDate;
      this.ssnSnapshot = data.studentSsn;
      this.unmaskedSsnumber = data.studentSsn;
      this.studentSie = data.studentSie;
      this.contacts = data.contacts;
      this.ethnicities = this.getEthnicityById(data.ethnicityId);
      this.gender = this.getGenderById(data.genderId);
      this.referralStatusId = data.referralStatusId;
      this.healthRegion = this.getHealthRegionById(data.healthRegionId);
      this.partCDate = data.partCDate;
      this.additionalComment = data.additionalComment;
      this.requestTypeId = data.requestTypeId;
      this.setLocations(data.locations);
      this.$nextTick(() => this.onSsnModelLoad(this.ssnSnapshot));
    },
    async handleRelatedStudent() {
      const isValid = await this.$refs.relateStudentForm.validate();

      if (!isValid) return;

      const payload = {
        pcStudentId: this.pcStudentId,
        eduespSie: this.relatedStudentSie
      };

      let message = "";
      let type = 0;
      let canSubmit = false;

      await StudentServices.validateReferralStudent(payload)
        .then(r => {
          message = `¿Está seguro(a) que desea relacionar el número de SIE ${this.relatedStudentSie} al estudiante ${this.name} ${this.lastName}?`;
          if (!r.data.status) {
            message = r.data.message;
            type = r.data.type;
          }

          canSubmit = true;
        })
        .catch(error => {
          this.ShowToast("Alerta", error.response.data.message, "error");
        });

      if (canSubmit) {
        const answer = await this.ShowCancelModal("Relacionar SIE", message);

        if (!answer) return;

        await StudentServices.relateReferralStudent(payload)
          .then(async ({ data }) => {
            if (data) {
              this.ShowToast(
                "Proceso Existoso",
                validationResponseType.duplicated == type
                  ? "El número de SIE fue relacionado y la solicitud fue inactivada exiosamente."
                  : "El número de SIE ha sido relacionado al estudiante seleccionado exitosamente.",
                "success"
              );
              await this.loadReferralDetail();
            }
          })
          .catch(err =>
            this.ShowToast(
              "",
              err.message || err.response.data.message,
              "error"
            )
          );
      }
    },
    async clearRelateSieValidation() {
      this.relatedStudentSie = null;
      await this.$refs.relateStudentForm.reset();
    },
    setModelForSave() {
      this.model = {
        pcStudentId: this.pcStudentId,
        regionId: this.healthRegion.id,
        firstName: this.name,
        initials: this.initials,
        lastNames: this.lastName,
        bornDate: this.bornDate,
        transitionDate: this.dateTransition,
        genderId: this.gender?.id,
        ethnicityId: this.ethnicities?.id,
        age:
          !this.calculateAge || this.calculateAge == "-"
            ? null
            : Number(this.calculateAge),
        studentSsn: this.unmaskedSsnumber,
        referralDate: this.dateB,
        partCDate: this.partCDate,
        additionalComment: this.additionalComment
      };

      this.model.age =
        !this.calculateAge || this.calculateAge == "-"
          ? null
          : Number(this.calculateAge);
    },
    customSsnValidate() {
      this.customSsnErrors = [];

      let isValidSsn =
        this.unmaskedSsnumber === null || this.unmaskedSsnumber?.length === 9;

      if (!isValidSsn)
        this.customSsnErrors.push("El número de seguro social es requerido");

      return isValidSsn;
    },
    validateRelation() {
      let result = false;
      if (this.contacts.length) {
        result = this.contacts.every(
          c => c.name && c.surname && c.email && c.phone1 && c.relationshipId
        );
      }
      this.showRelationError = !result;

      return result;
    },
    validateAddress() {
      const postal = this.addresses.postal.model;
      const postalIsValid =
        postal.address1 && postal.municipalityId && postal.zipCode;
      this.addresses.postal.model.showError = !postalIsValid;

      const physical = this.addresses.physical.model;
      const physicalIsValid =
        physical.address1 && physical.municipalityId && physical.zipCode;
      this.addresses.physical.model.showError = !postalIsValid;

      return postalIsValid && physicalIsValid;
    },
    async save() {
      const isHealthRegionValid = await this.$refs.healthRegionRef.validate();
      
      let isfistNameValid = { valid: true };
      let isLastNameValid = { valid: true };
      let isSsnValid = true;

      if (!this.canEditHealthRegion) {
        isfistNameValid = await this.$refs.firstNameProvider.validate();
        isLastNameValid = await this.$refs.lastNameProvider.validate();
        isSsnValid = this.customSsnValidate();
      }

      if (
        isSsnValid &&
        isHealthRegionValid &&
        isfistNameValid.valid &&
        isLastNameValid.valid &&
        this.ageIsValid
      ) {
        let response = await this.ShowCancelModal(
          "Atención",
          "¿Está seguro(a) que desea guardar la información presentada?",
          "Sí",
          "No"
        );

        if (response) {
          this.setModelForSave();

          StudentServices.saveStudent(this.model)
            .then(async () => {
              this.ShowToast(
                "Alerta",
                "La Información ha sido guardada exitosamente.",
                "success"
              );
              await this.getDataSelect();
              await this.loadReferralDetail();
            })
            .catch(err =>
              this.ShowToast("Alerta", err.response.data.message, "error")
            );
        }
      } else {
        this.ShowToast(
          "Alerta",
          "Favor completar la Información solicitada.",
          "error"
        );
      }
    },
    async submit(confirmed = false) {
      const isHealthRegionValid = await this.$refs.healthRegionRef.validate();
      const isPartCDateValid = await this.$refs.partCDateRef.validate();
      const boyIsValid = await this.$refs.boyGirlInfoForm.validate();
      const relationIsValid = this.validateRelation();
      const addressIsValid = this.validateAddress();
      const isSsnValid = this.customSsnValidate();

      if (
        !isSsnValid ||
        !isHealthRegionValid ||
        !isPartCDateValid ||
        !boyIsValid ||
        !relationIsValid ||
        !addressIsValid ||
        !this.ageIsValid
      ) {
        this.ShowToast(
          "Alerta",
          "Favor completar la Información solicitada.",
          "error"
        );

        return;
      }

      if (this.calculateAge >= this.maximumAge) {
        await this.ShowAlertModal(
          "Atención",
          "No es posible someter la solicitud ya que el estudiante cuenta con más de la Edad permitida en el referido de salud."
        );
        return;
      } else if (
        this.calculateAge >= this.validationAge &&
        this.calculateAge <= this.maximumAge
      ) {
        let ageResponse = await this.ShowCancelModal(
          "Confirmación",
          "La edad documentada se encuentra fuera de término, ¿Está seguro(a) que desea someter la solicitud?",
          "Sí",
          "No"
        );
        if (!ageResponse) return;
      }

      if (!confirmed) {
        let response = await this.ShowCancelModal(
          "Atención",
          "¿Está seguro(a) que desea someter la información presentada?",
          "Sí",
          "No"
        );

        if (!response) return;
      }

      try {
        this.setModelForSave();
        this.model.confirmed = confirmed;
        await StudentServices.submitStudent(this.model)
          .then(async () => {
            this.ShowToast(
              "Alerta",
              "La información ha sido sometida exitosamente.",
              "success"
            );
            await this.getDataSelect();
            await this.loadReferralDetail();
          })
          .catch(async err => {
            const continueProcess = await this.ShowCancelModal(
              "Confirmación",
              err.response.data.message,
              "Sí",
              "No"
            );
            if (!continueProcess) return;
            await this.submit(true);
          });
      } catch (err) {
        this.ShowToast("Alerta", err.response.data.message, "error");
      }
    },
    onChangePhysicalAddress() {
      const value = this.enableCopyFisicalAddress
        ? { ...this.addresses.physical.model }
        : { ...this.addresses.postal.initial };
      this.addresses.postal.model.address1 = value.address1;
      this.addresses.postal.model.address2 = value.address2;
      this.addresses.postal.model.municipality = value.municipality;
      this.addresses.postal.model.zipCode = value.zipCode;
    }
  }
};
</script>
<style lang="scss" scoped>
.center {
  margin-left: 6px;
  margin-top: 7px;
}
.phone-icon {
  display: inline-block;
  font-size: 18px;
  line-height: 32px;
  background-color: #ff7058;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  text-align: center;
  vertical-align: bottom;
}
.edit-icon {
  display: inline-block;
  font-size: 20px;
  line-height: 32px;
  background-color: #2eb882;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 15%;
  text-align: center;
  vertical-align: bottom;
}
.edit-icon:hover {
  background-color: #2b9d71;
}
.only-read {
  color: #11291b;
}
.custom-rounded {
  border-radius: 5px;
}
.detail-referra-custom-error {
  color: #fb5858;
  margin-left: 4px;
  margin-top: 2px;
}
.detail-referra-custom-error > i {
  font-size: 18px;
}
.detail-referra-custom-error > span {
  margin-left: 5px;
  font-size: 14px;
}
.detail-referral-custom-error em {
  font-size: 18px;
  padding-right: 10px;
}
.detail-referral-custom-error p {
  font-size: 14px;
}
.select-dropdown {
  height: 38px;
}

.container-region {
  margin-left: 2px;
}
.dropdown-region {
  width: 300px;
}
</style>
